module.exports = __webpack_public_path__ + "static/media/red-hot-deals-rsr.8a048b0c.jpg";